import request from "./api";
/**
 *    discussApi   学习中心讨论api
 * */
// 获取讨论列表
export const getDiscussList = (params, opts) =>
    request('/api-study/discussion/getDiscussionList', params, {
        ...opts,
        method: 'post'
    });
// 查看讨论详情
export const getDiscussDetail = (params, opts) =>
    request('/api-study/discussion/insertView', params, {
        ...opts,
        method: 'post'
    });
// 获取全部章节目录
export const getChapter = (courseId, params, opts) =>
    request('/api-course/catalog/catalog/'+courseId, params, {
        ...opts
    });
// 置顶条数
export const getTopNum = (params, opts) =>
    request('/api-study/discussion/getRoofPlacementCount', params, {
        ...opts,
        method: 'post'
    });
// 发表讨论
export const publishDiscuss = (params, opts) =>
    request('/api-study/discussion/insertDiscussion', params, {
        ...opts,
        method: 'post'
    });
// 编辑讨论
export const publishDiscussUpdate = (params, opts) =>
    request('/api-study/discussion/updateDiscussion', params, {
        ...opts,
        method: 'put'
    });
// 获取讨论的评论
export const getReplyList = (params, opts) =>
    request('/api-study/discussion/getDiscussionAndReply', params, {
        ...opts,
        method: 'post'
    });
// 讨论同问
export const sameQuestion = (params, opts) =>
    request('/api-study/discussionSameQuestion', params, {
        ...opts,
        method: 'post'
    });
// 点赞或取消点赞讨论(评论)
export const likedDiscuss = (params, opts) =>
    request('/api-study/discussionSamePraise', params, {
        ...opts,
        method: 'post'
    });
// 删除讨论
export const deleteDiscussion = (id, params, opts) =>
    request('/api-study/discussion/deleteDiscussion/'+id, params, {
        ...opts,
        method: 'delete'
    });
// 发表或删除评论
export const publishDeleteReply = (params, opts) =>
    request('/api-study/discussion/insertOrDeleteReply', params, {
        ...opts,
        method: 'post'
    });
// 删除或发布评论
export const deletePublishComment = (params, opts) =>
    request('/api-study/discussion/insertOrDeleteDiscuss', params, {
        ...opts,
        method: 'post'
    });
// 查看评论
export const replyComment = (params, opts) =>
    request('/api-study/discussion/getReplyAndComment', params, {
        ...opts,
        method: 'post'
    });
// 根据课程id获取全部的讨论
export const getCourseAllDiscuss = (params, opts) =>
    request('/api-study/discussion/getDiscussionListAllByCourseId', params, {
        ...opts,
        method: 'post'
    });
// 所有的教学班
export const getAllTeachClass = (courseId, params, opts) =>
    request('/api-course/class/teacher/'+courseId, params, {
        ...opts
    });


// WEBPACK FOOTER //
// ./src/api/discussApi.js